import * as React from 'react';

import { ICodeCheckProps } from './code-check.types';
import Spinner from 'components/spinner/spinner.component';

class CodeCheck extends React.Component<ICodeCheckProps> {
    public componentDidMount() {
        const { redeemCode } = this.props;
        redeemCode();
    }

    public render() {
        return (
            <div className="sitegen-redeem-code-check">
                <Spinner />
            </div>
        );
    }
}

export default CodeCheck;
